<template>
  <div
    class="collegeTeamHighlight-card"
    v-match-heights="{
      el: [
        '.img-wrap',
        '.collegeTeamHighlight-body',
        '.collegeTeamHighlight-footer'
      ],
      disabled: [575]
    }"
  >
    <div class="img-wrap">
      <img :src="generateImageUrl(collegeTeamHighlight.image)" />
    </div>
    <div class="collegeTeamHighlight-body">
      <div class="collegeTeamHighlight-title">
        <div class="name">
          <span>{{ collegeTeamHighlight.title }}</span>
        </div>
      </div>
      <ul class="collegeTeamHighlight-description">
        <li>
          <div class="list-title">Created:</div>
          <div class="list-info">
            {{ new Date(collegeTeamHighlight.createdAt).toDateString() }}
          </div>
        </li>
        <li>
          <div class="list-title">Description:</div>
          <div class="list-info w-space-preline">{{ collegeTeamHighlight.description }}</div>
        </li>
      </ul>
    </div>
    <div class="collegeTeamHighlight-footer">
      <div class="button-wrap">
        <router-link
          :to="
            $route.params.id
              ? `/${profileId}/college_profile/team_highlights/${collegeTeamHighlight.id}/show/${$route.params.id}`
              : `/${profileId}/college_profile/team_highlights/${collegeTeamHighlight.id}/show`
          "
        >
          <div class="view-details">
            View Details
            <a-icon type="double-right" />
          </div>
        </router-link>
      </div>
      <div
        class="button-wrap"
        v-if="
          !$route.params.id &&
            (onlyCollegeHeadCoach() || onlyCollegeProfileMaintainer())
        "
      >
        <span>
          <a-button
            type="primary"
            icon="edit"
            class="save-button"
            @click="handleEdit"
            >Edit</a-button
          >
        </span>
        <span>
          <a-popconfirm
            title="Are you sure you want to delete this highlight?"
            @confirm="handleDelete()"
            ok-text="Yes"
            cancel-text="No"
          >
            <a-button type="danger" icon="delete">Delete</a-button>
          </a-popconfirm>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Base } from "@/models";
const STORE_KEY = "collegeTeamHighlightStore";

export default {
  name: "collegeTeamHighlightCard",
  props: {
    collegeTeamHighlight: {
      type: Object,
      required: true
    }
  },
  computed: {
    profileId() {
      return Base.profileId();
    }
  },
  methods: {
    async handleDelete() {
      await this.$store.dispatch(`${STORE_KEY}/deleteCollegeTeamHighlights`, {
        id: this.collegeTeamHighlight.id,
        slug: "collegehighlight"
      });
      this.$store.dispatch(`${STORE_KEY}/afterDeleteActions`, {
        id: this.collegeTeamHighlight.id
      });
    },
    handleEdit() {
      this.$router.push(
        `/${this.profileId}/college_profile/team_highlights/${this.collegeTeamHighlight.id}/edit`
      );
    }
  }
};
</script>

<style lang="scss">
.collegeTeamHighlight-card {
  border-radius: 4px;
  overflow: hidden;
  max-width: 300px;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0px 4px 10px 5px rgba(209, 209, 209, 0.6);
  .img-wrap {
    overflow: hidden;
    display: flex;
    max-height: 250px;
    background: #f0f0f0;
    img {
      margin: 0 auto;
      height: 100%;
      object-fit: cover;
    }
  }
  .collegeTeamHighlight-body {
    padding: 15px 15px;
    .collegeTeamHighlight-title {
      display: flex;
      justify-content: space-between;
      .name {
        font-size: 14px;
        font-weight: 500;
        padding-bottom: 5px;
        margin-bottom: 15px;
        position: relative;
        text-transform: capitalize;
        color: #4a4a4a;
        span {
          font-size: 18px;
          font-weight: 900;
          color: #2d2d2d;
          display: block;
        }
        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3px;
          max-width: 100px;
          background: #cc2f2a;
        }
      }
      .view-details {
        font-size: 12px;
        font-weight: 600;
        color: #2a328a;
        text-align: left;
        font-style: italic;
        padding-bottom: 2px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          height: 1px;
          width: 100%;
          background: #2a328a;
        }
      }
    }
    .collegeTeamHighlight-description {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        padding: 3px 0;
        color: #4a4a4a;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        .list-title {
          font-weight: 600;
          color: #000000;
          width: 100px;
        }
        .list-info {
          padding-left: 10px;
          width: calc(100% - 100px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          padding-bottom: 0;
          // .list-info {
          //   padding-left: 0;
          //   padding-top: 5px;
          //   width: 100%;
          // }
        }
      }
    }
  }
  .collegeTeamHighlight-footer {
    padding: 15px 15px;
    background: #fff;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    .view-details {
      color: #2a328a;
      text-align: left;
      &.deactivate {
        color: #d73228;
        cursor: pointer;
      }
      &.activate {
        color: green;
        cursor: pointer;
      }
    }
    .button-wrap {
      // display: none;
      padding-top: 15px;
      display: flex;
      justify-content: space-between;
      .ant-btn {
        font-size: 12px;
        padding: 0 15px;
        line-height: 26px;
        height: 28px;
      }
      .save-button {
        background: #2a328a;
        border-color: #2a328a;
      }
    }
  }
}
</style>
